var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { ChartParams } from "../../views/chart/chart.component";
import { EventsService } from "../../lib/EventsService";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "../../translate";
import { ModalService } from "../../views/modal/base_modal.component";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { HelperService } from "../../lib/helper.service";
import { BillingService2 } from "../billing.service";
var PromopultComponent = /** @class */ (function (_super) {
    __extends(PromopultComponent, _super);
    function PromopultComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.helper = helper;
        _this.service2 = service2;
        _this.regAndPaidChart = new ChartParams();
        _this.firstAndManualChart = new ChartParams();
        _this.siteChart = new ChartParams({
            title: 'Сайты',
            type: 'bar',
            axis: {
                x: {
                    show: true,
                    label: {
                        text: 'Дата создания сайта',
                        position: 'outer-middle'
                    }
                },
                y: {
                    show: true,
                    label: {
                        text: 'Сайты',
                        position: 'outer-middle'
                    }
                }
            },
        });
        _this.statsLoader = false;
        _this.statsLoader2 = false;
        _this.totalStatLoader = false;
        _this.addFilterParams = {
            period: 'month',
        };
        var me = _this;
        me.regAndPaidChart.setOptions({
            title: me.translate.__A('promopult.regAndPaid'),
            names: {
                'countReg': _this.translate.__A('users.reg_day.countReg'),
                'paidCount': _this.translate.__A('common.paidCount'),
            },
        });
        me.firstAndManualChart.setOptions({
            title: me.translate.__A('promopult.firstAndManual'),
            names: {
                'firstPaidCount': _this.translate.__A('billing.billing.firstPaidCount'),
                'repeatPaidCount': _this.translate.__A('billing.billing.repeatPaidCount'),
            },
        });
        me.siteChart.setOptions({
            names: {
                'siteCount': _this.translate.__A('users.reg_day.created sites'),
            },
        });
        return _this;
    }
    PromopultComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCharts()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getTotalStats()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getSitesStats()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromopultComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.service2.promopultBilling.stats(__assign({}, me.filter.getFilterParams(), { period: 'month' })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.promopultStats = stats;
                        me.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PromopultComponent.prototype.getTotalStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.totalStatLoader = true;
                        return [4 /*yield*/, me.service2.promopultBilling.stats(__assign({}, me.filter.getFilterParams()), 'total_stats').toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.promopultTotalStats = stats;
                        me.totalStatLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PromopultComponent.prototype.getSitesStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _a, stats, pagination;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.statsLoader2 = true;
                        return [4 /*yield*/, me.service2.promopultBilling.stats(__assign({}, me.filter.getFilterParams(), { period: 'month' }), 'sites_stats').toPromise()];
                    case 1:
                        _a = _b.sent(), stats = _a.stats, pagination = _a.pagination;
                        if (pagination) {
                            me.pagination.fill(pagination);
                            me.updateLinks(me.service2.promopultBilling.getRealFullRoute());
                        }
                        me.siteStats = stats;
                        me.statsLoader2 = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PromopultComponent.prototype.getCharts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, regAndPaidData, firstAndManualData, siteChartData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        // chart 1
                        me.regAndPaidChart.showLoader();
                        return [4 /*yield*/, me.service2.promopultBilling.chart(me.filter.getFilterParams(), 'regAndPaidChart').toPromise()];
                    case 1:
                        regAndPaidData = (_a.sent()).charts;
                        me.regAndPaidChart.data = regAndPaidData;
                        me.regAndPaidChart.hideLoader();
                        // chart 2
                        me.firstAndManualChart.showLoader();
                        return [4 /*yield*/, me.service2.promopultBilling.chart(me.filter.getFilterParams(), 'firstAndManualChart').toPromise()];
                    case 2:
                        firstAndManualData = (_a.sent()).charts;
                        me.firstAndManualChart.data = firstAndManualData;
                        me.firstAndManualChart.hideLoader();
                        // chart 3
                        me.siteChart.showLoader();
                        return [4 /*yield*/, me.service2.promopultBilling.chart(me.filter.getFilterParams(), 'site/chart').toPromise()];
                    case 3:
                        siteChartData = (_a.sent()).charts;
                        me.siteChart.data = siteChartData;
                        me.siteChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    PromopultComponent.prototype.onPageChange = function (page) {
        if (page === void 0) { page = 1; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filter.filterParams.page = this.pagination.page;
                        return [4 /*yield*/, this.getSitesStats()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return PromopultComponent;
}(BaseComponent));
export { PromopultComponent };
